import request from '@/utils/request'

export function authorizeOperations(data) {
  return request({
    url: '/monitor/operations/sso/authorize',
    method: 'post',
    data,
    ...(process.env.NODE_ENV === 'development' && process.env.VUE_APP_OPERATIONS_API_BASE_URL
      ? { baseURL: process.env.VUE_APP_OPERATIONS_API_BASE_URL }
      : {}),
  })
}
